import { getData, getTimestampDataNew, exportDataNew,statisticsExport } from '@/services/statictimeeffect';
import { handleDataOrNull } from '../../../utils/formatUtil';
import { message } from 'antd';
import { isArray } from 'lodash';
import moment from 'moment';

// const weekdays = '周日_周一_周二_周三_周四_周五_周六'.split('_')

const endDateFormat = 'YYYY-MM-DD 00:00:00';
const params = {
  productType: [],
  direction: '',
  directionType: 0,
  centerType: "900100",
  startDate: moment().subtract(1, 'days').format(endDateFormat),
  endDate: moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
};
const dealDate = (start, end) => {
  let dateList = [];
  var startTime = new Date(start);
  var endTime = new Date(end);

  while (endTime.getTime() - startTime.getTime() >= 0) {
    var year = startTime.getFullYear();
    var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
    var day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate();
    dateList.push(year + '-' + month + '-' + day);
    // const week = weekdays[startTime.getDay()]
    // dateList.push(month + '/' + day + '\n' + week);
    startTime.setDate(startTime.getDate() + 1);
  }

  return dateList;
};



export default {
  namespace: 'staticcashrateFresh',
  state: {
    activeKey: 'organization',
    //
    // searchParams: { ...params },

    orgSearch: { ...params },
    counSearch: { ...params },

    organizationTable: [],
    countryTable: [],
    orgPage: 1,
    orgPageSize: 20,
    counPage: 1,
    counPageSize: 20,
    dataSql: '',

    countryProductDataList: [],
    countryTimestamps: dealDate(
      moment(params.startDate).format('YYYY-MM-DD'),
      moment(params.endDate).format('YYYY-MM-DD'),
    ),
    organizationProductDataList: [],
    organizationTimestamps: dealDate(
      moment(params.startDate).format('YYYY-MM-DD'),
      moment(params.endDate).format('YYYY-MM-DD'),
    ),
    productDataSql: '',
    exportVisible:false,
  },

  effects: {
    *getData(_, { put, call, select }) {
      const { orgSearch, counSearch, orgPage, orgPageSize, counPage, counPageSize, activeKey } = yield select(
        ({ staticcashrateFresh }) => staticcashrateFresh,
      );
      let searchParams = null;
      if (activeKey === 'organization') {
        searchParams = { ...orgSearch, pageSize: orgPageSize, page: orgPage }
      }
      if (activeKey === 'country') {
        searchParams = { ...counSearch, pageSize: counPageSize, page: counPage }
      }
      const directionType = searchParams.directionType || 0

      let params: any = {
        startDate: moment(searchParams.startDate).format('YYYY-MM-DD'),
        endDate: moment(searchParams.endDate).format('YYYY-MM-DD'),
        planTime: searchParams.planTime,
        planNum: searchParams.ecticyVal,
        centerType: searchParams.centerType,
        productType: searchParams.productType?.map((e) => e.value) || [],
        directionType: searchParams.directionType,
        pageSize: searchParams.pageSize,
        page: searchParams.page,
      }
      if (searchParams.departureCenter) {
        if (isArray(searchParams.departureCenter)) {
          searchParams.departureCenter = searchParams.departureCenter?.map((item) => item.value);
        } else {
          searchParams.departureCenter = [searchParams.departureCenter?.code];
        }
      }
      if (searchParams.arrivalCenter) {
        if (isArray(searchParams.arrivalCenter)) {
          searchParams.arrivalCenter = searchParams.arrivalCenter?.map((item) => item.value);
        } else {
          searchParams.arrivalCenter = [searchParams.arrivalCenter?.code];
        }
      }
      const departureCenter = searchParams.departureCenter || [];
      const arrivalCenter = searchParams.arrivalCenter || [];
      if (directionType === 1) {//营运区-全国
        params.originProvinceArea = departureCenter;
      } else if (directionType === 2) {//营运区-营运区
        params.originProvinceArea = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 3) {//分拨-分拨
        params.originCenter = departureCenter;
        params.destinationCenter = arrivalCenter;
      } else if (directionType === 4) {//分拨-营运区
        params.originCenter = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 5) {//分拨-全国
        params.originCenter = departureCenter;
      } else if (directionType === 6) {//省-全国
        params.originProvince = departureCenter;
      } else if (directionType === 7) {//省-省
        params.originProvince = departureCenter;
        params.destinationProvince = arrivalCenter;
      } else if (directionType === 8) {//市-市
        params.originCity = departureCenter;
        params.destinationCity = arrivalCenter;
      } else if (directionType === 9) {//市-全国
        params.originCity = departureCenter;
      } else if (directionType === 10) {//区县-全国
        params.originCounty = departureCenter;
      }
      const data = yield getData(params);
      if (data.code == 1) {
        const dataList = handleDataOrNull(data.data.rows, ["origin", "destination", "signTime"])
        if (activeKey === 'organization') {
          yield put({
            type: 'updateState',
            payload: { organizationTable: dataList, orgPage: 1, orgPageSize: 20 },
          });
        }
        if (activeKey === 'country') {
          yield put({
            type: 'updateState',
            payload: { countryTable: dataList, counPage: 1, counPageSize: 20 },
          });
        }

      }
    },
    // 图表
    * getProduct(_, { put, call, select }) {
      const { orgSearch, counSearch, orgPage, orgPageSize, counPage, counPageSize, activeKey } = yield select(
        ({ staticcashrateFresh }) => staticcashrateFresh,
      );
      let searchParams = null;
      if (activeKey === 'organization') {
        searchParams = { ...orgSearch, pageSize: orgPageSize, page: orgPage }
      }
      if (activeKey === 'country') {
        searchParams = { ...counSearch, pageSize: counPageSize, page: counPage }
      }
      const directionType = searchParams.directionType || 0
      let params: any = {
        startDate: moment(searchParams.startDate).format('YYYY-MM-DD'),
        endDate: moment(searchParams.endDate).format('YYYY-MM-DD'),
        planTime: searchParams.planTime,
        planNum: searchParams.ecticyVal,
        centerType: searchParams.centerType,
        productType: searchParams.productType?.map((e) => e.value) || [],
        directionType: searchParams.directionType,
        pageSize: searchParams.pageSize,
        page: searchParams.page,
      }
      if (searchParams.departureCenter) {
        if (isArray(searchParams.departureCenter)) {
          searchParams.departureCenter = searchParams.departureCenter?.map((item) => item.value);
        } else {
          searchParams.departureCenter = [searchParams.departureCenter?.code];
        }
      }
      if (searchParams.arrivalCenter) {
        if (isArray(searchParams.arrivalCenter)) {
          searchParams.arrivalCenter = searchParams.arrivalCenter?.map((item) => item.value);
        } else {
          searchParams.arrivalCenter = [searchParams.arrivalCenter?.code];
        }
      }
      const departureCenter = searchParams.departureCenter || [];
      const arrivalCenter = searchParams.arrivalCenter || [];
      if (directionType === 1) {//营运区-全国
        params.originProvinceArea = departureCenter;
      } else if (directionType === 2) {//营运区-营运区
        params.originProvinceArea = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 3) {//分拨-分拨
        params.originCenter = departureCenter;
        params.destinationCenter = arrivalCenter;
      } else if (directionType === 4) {//分拨-营运区
        params.originCenter = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 5) {//分拨-全国
        params.originCenter = departureCenter;
      } else if (directionType === 6) {//省-全国
        params.originProvince = departureCenter;
      } else if (directionType === 7) {//省-省
        params.originProvince = departureCenter;
        params.destinationProvince = arrivalCenter;
      } else if (directionType === 8) {//市-市
        params.originCity = departureCenter;
        params.destinationCity = arrivalCenter;
      } else if (directionType === 9) {//市-全国
        params.originCity = departureCenter;
      } else if (directionType === 10) {//区县-全国
        params.originCounty = departureCenter;
      }
      const data = yield getTimestampDataNew(params);
      if (data.code == 1 && data.data) {
        const dataList = handleDataOrNull(data.data)
        // 获取时间范围
        const timestamps = dealDate(
          moment(params.startDate).format('YYYY-MM-DD'),
          moment(params.endDate).format('YYYY-MM-DD'),
        );
        // 计算单日兑现率
        const RedemptionRate = timestamps.map((i) => {
          const actualItem = dataList.find(
            (item) => moment(i).format('YYYY-MM-DD') === moment(item?.signTime).format('YYYY-MM-DD'),
          );
          const ratio = actualItem?.cashingRate;
          return ratio ? Number.parseFloat(((ratio || 0) * 1).toFixed(1)) : 0;
        });
        const productDataList = [{ name: `${'全产品'}(%)`, value: RedemptionRate }];
        console.log("productDataList", productDataList);
        if (activeKey === 'organization') {
          yield put({
            type: 'updateState',
            payload: { organizationProductDataList: productDataList, organizationTimestamps: timestamps, },
          });
        }
        if (activeKey === 'country') {
          yield put({
            type: 'updateState',
            payload: { countryProductDataList: productDataList, countryTimestamps: timestamps },
          });
        }

      }

    },
    // 导出
    * export(_, { put, call, select }) {
      const { orgSearch, counSearch, orgPage, orgPageSize, counPage, counPageSize, activeKey } = yield select(
        ({ staticcashrateFresh }) => staticcashrateFresh,
      );
      let searchParams = null;
      if (activeKey === 'organization') {
        searchParams = { ...orgSearch, pageSize: orgPageSize, page: orgPage }
      }
      if (activeKey === 'country') {
        searchParams = { ...counSearch, pageSize: counPageSize, page: counPage }
      }
      const directionType = searchParams.directionType || 0
      let params: any = {
        startDate: moment(searchParams.startDate).format('YYYY-MM-DD'),
        endDate: moment(searchParams.endDate).format('YYYY-MM-DD'),
        planTime: searchParams.planTime,
        planNum: searchParams.ecticyVal,
        centerType: searchParams.centerType,
        productType: searchParams.productType?.map((e) => e.value) || [],
        directionType: searchParams.directionType,
        pageSize: searchParams.pageSize,
        page: searchParams.page,
      }
      if (searchParams.departureCenter) {
        if (isArray(searchParams.departureCenter)) {
          searchParams.departureCenter = searchParams.departureCenter?.map((item) => item.value);
        } else {
          searchParams.departureCenter = [searchParams.departureCenter?.code];
        }
      }
      if (searchParams.arrivalCenter) {
        if (isArray(searchParams.arrivalCenter)) {
          searchParams.arrivalCenter = searchParams.arrivalCenter?.map((item) => item.value);
        } else {
          searchParams.arrivalCenter = [searchParams.arrivalCenter?.code];
        }
      }

      const departureCenter = searchParams.departureCenter || [];
      const arrivalCenter = searchParams.arrivalCenter || [];
      if (directionType === 1) {//营运区-全国
        params.originProvinceArea = departureCenter;
      } else if (directionType === 2) {//营运区-营运区
        params.originProvinceArea = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 3) {//分拨-分拨
        params.originCenter = departureCenter;
        params.destinationCenter = arrivalCenter;
      } else if (directionType === 4) {//分拨-营运区
        params.originCenter = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 5) {//分拨-全国
        params.originCenter = departureCenter;
      } else if (directionType === 6) {//省-全国
        params.originProvince = departureCenter;
      } else if (directionType === 7) {//省-省
        params.originProvince = departureCenter;
        params.destinationProvince = arrivalCenter;
      } else if (directionType === 8) {//市-市
        params.originCity = departureCenter;
        params.destinationCity = arrivalCenter;
      } else if (directionType === 9) {//市-全国
        params.originCity = departureCenter;
      } else if (directionType === 10) {//区县-全国
        params.originCounty = departureCenter;
      }
      const data = yield exportDataNew(params);
      try {
        if (data?.code === 1) {
          message.success('导出成功');
        }
      } catch (err) {
        message.warn(err.message);
      }

    },



    // 导出
    *statisticsExport({ payload }, { put, call, select }) {
      const { orgSearch, counSearch, orgPage, orgPageSize, counPage, counPageSize, activeKey } = yield select(
        ({ staticcashrateFresh }) => staticcashrateFresh,
      );
      let searchParams = null;
      if (activeKey === 'organization') {
        searchParams = { ...orgSearch, pageSize: orgPageSize, page: orgPage }
      }
      if (activeKey === 'country') {
        searchParams = { ...counSearch, pageSize: counPageSize, page: counPage }
      }
      const directionType = searchParams.directionType || 0
      let params: any = {
        startDate: moment(searchParams.startDate).format('YYYY-MM-DD'),
        endDate: moment(searchParams.endDate).format('YYYY-MM-DD'),
        planTime: searchParams.planTime,
        planNum: searchParams.ecticyVal,
        centerType: searchParams.centerType,
        productType: searchParams.productType?.map((e) => e.value) || [],
        directionType: searchParams.directionType,
        pageSize: searchParams.pageSize,
        page: searchParams.page,
        ...payload
      }
      if (searchParams.departureCenter) {
        if (isArray(searchParams.departureCenter)) {
          searchParams.departureCenter = searchParams.departureCenter?.map((item) => item.value);
        } else {
          searchParams.departureCenter = [searchParams.departureCenter?.code];
        }
      }
      if (searchParams.arrivalCenter) {
        if (isArray(searchParams.arrivalCenter)) {
          searchParams.arrivalCenter = searchParams.arrivalCenter?.map((item) => item.value);
        } else {
          searchParams.arrivalCenter = [searchParams.arrivalCenter?.code];
        }
      }

      const departureCenter = searchParams.departureCenter || [];
      const arrivalCenter = searchParams.arrivalCenter || [];
      if (directionType === 1) {//营运区-全国
        params.originProvinceArea = departureCenter;
      } else if (directionType === 2) {//营运区-营运区
        params.originProvinceArea = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 3) {//分拨-分拨
        params.originCenter = departureCenter;
        params.destinationCenter = arrivalCenter;
      } else if (directionType === 4) {//分拨-营运区
        params.originCenter = departureCenter;
        params.destinationProvinceArea = arrivalCenter;
      } else if (directionType === 5) {//分拨-全国
        params.originCenter = departureCenter;
      } else if (directionType === 6) {//省-全国
        params.originProvince = departureCenter;
      } else if (directionType === 7) {//省-省
        params.originProvince = departureCenter;
        params.destinationProvince = arrivalCenter;
      } else if (directionType === 8) {//市-市
        params.originCity = departureCenter;
        params.destinationCity = arrivalCenter;
      } else if (directionType === 9) {//市-全国
        params.originCity = departureCenter;
      } else if (directionType === 10) {//区县-全国
        params.originCounty = departureCenter;
      }
      const data = yield statisticsExport(params);
      try {
        if (data?.code === 1) {
          message.success('导出成功');
        }
        yield put({
          type: 'updateState',
          payload: { exportVisible: false },
        });
      } catch (err) {
        message.warn(err.message);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    // updateSearchParams(state, { payload }) {
    //   return { ...state, searchParams: { ...state.searchParams, ...payload } };
    // },
    updateCounty(state, { payload }) {
      return { ...state, counSearch: { ...state.counSearch, ...payload } };
    },
    updateOrganization(state, { payload }) {
      return { ...state, orgSearch: { ...state.orgSearch, ...payload } };
    },
  },
};

const productTypeList = [
  { key: 'productType', value: '定时达', label: '定时达' },
  { key: 'superiorityProduct', value: '是', label: '优势业务' },
  // { key: 'lengthOfTime', value: '次日达', label: '次日达' },
  // { key: 'lengthOfTime', value: '隔日达', label: '隔日达' },
];

const handleParams = (searchParams) => {
  const { productType, direction, departureCenter, arrivalCenter } = searchParams;
  let dimensions = null; // 聚合
  let searchData = {};
  // 处理出发到达组织 andfilters
  if (direction) {
    dimensions = direction.split(',');
    if (dimensions.length === 1) {
      if (isArray(departureCenter)) {
        searchData[dimensions[0]] = departureCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[0]] = departureCenter?.code;
      }
    }
    if (dimensions.length === 2) {
      if (isArray(departureCenter)) {
        searchData[dimensions[0]] = departureCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[0]] = departureCenter?.code;
      }

      if (isArray(arrivalCenter)) {
        searchData[dimensions[1]] = arrivalCenter?.map((item) => item.value);
      } else {
        searchData[dimensions[1]] = arrivalCenter?.code;
      }
    }
  }
  // 处理产品类型productLinType  andfilters
  if (productType && productType.length > 0) {
    productType.forEach((item) => {
      const { value } = item;
      const obj = productTypeList.find((i) => i.value === value);
      if (obj?.key) {
        searchData = { ...searchData, [obj?.key]: obj?.value };
      }
    });
  }
  return { dimensions: dimensions?.map((item) => item.replace('Code', '')), searchData };
};


